import { dehydrate } from '@tanstack/react-query'
import { GetServerSideProps } from 'next/types'
import { getProps } from 'ssr/getProps'
import { runWithAmplifyServerContext, serverClient } from 'web-amplify/server'

import { getWorkspacesQuery } from '~workspaces/api/getWorkspaces'
import {
  getWorkspacesQueryKey,
  limit
} from '~workspaces/queries/useGetWorkspaces'

const getServerSideProps: GetServerSideProps<any> = getProps(
  async (context, client) => {
    const page = Number(context?.query?.page || 1)

    const { data } = (await runWithAmplifyServerContext({
      nextServerContext: { request: context.req, response: context.res },
      operation: async (ctx) => {
        return serverClient.graphql(ctx, {
          query: getWorkspacesQuery,
          variables: {
            limit,
            offset: (page - 1) * limit,
            mapFilter: {
              isPublic: true
            }
          }
        })
      }
    })) as any

    await client.prefetchQuery({
      queryKey: getWorkspacesQueryKey(page),
      queryFn: () => data?.getWorkspaces
    })

    const { total = 0 } = client.getQueryData(getWorkspacesQueryKey(page)) as {
      total?: number
    }

    const hasNextPage = total > page * limit

    return {
      props: {
        dehydratedState: dehydrate(client),
        page,
        hasNextPage
      }
    }
  }
)

export { getServerSideProps }
